'use client'

import type { GlossaryTerm } from '@/modules/glossary/glossary.interface'

import { GLOSSARY_TEST_IDS } from '../../glossary.const'

import styles from './GlossaryTermsNav.module.scss'

type GlossaryTermsNavProps = {
  terms: GlossaryTerm[]
  activeTermId: string
  onTermClick: (termId: string) => void
}

export function GlossaryTermsNav({ terms, activeTermId, onTermClick }: GlossaryTermsNavProps) {
  return (
    <nav className={styles.nav} data-testid={GLOSSARY_TEST_IDS.termsNav}>
      <span className={styles.navTitle}>Terms</span>
      <div className={styles.linksContainer}>
        <div className={styles.inArticleNav}>
          <div className={styles.lineContainer}>
            <div className={styles.line} />
          </div>
          <div className={styles.navItems}>
            {terms.map((term) => {
              const isActive = term.id === activeTermId
              return (
                <button
                  key={term.id}
                  type="button"
                  className={`${styles.navItem} ${isActive ? styles.active : ''}`}
                  onClick={() => onTermClick(term.id)}
                >
                  <span className={styles.dotContainer}>{isActive && <span className={styles.dot} />}</span>
                  <span className={styles.navLabel}>{term.term}</span>
                </button>
              )
            })}
          </div>
        </div>
      </div>
    </nav>
  )
}
